import { render, staticRenderFns } from "./new-holland.vue?vue&type=template&id=6fdca8ea&"
import script from "./new-holland.vue?vue&type=script&lang=js&"
export * from "./new-holland.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports